import {ErrorHandler, NgModule} from '@angular/core';
import {ConfigLoader, ConfigModule} from '@ngx-config/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {ConfigHttpLoader} from '@ngx-config/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import Bugsnag from '@bugsnag/js';
import {BugsnagChunkLoadErrorHandler} from './handler/BugsnagChunkLoadErrorHandler';
import {ChunkLoadErrorHandler} from './handler/ChunkLoadErrorHandler';
import {SharedModule} from '../shared/shared.module';
import {ImageDetailComponent} from './components/image-detail/image-detail.component';
import {PhotoDetailComponent} from './components/photo-detail/photo-detail.component';
import player from 'lottie-web';
import {SnackbarComponent} from "./components/snackbar/snackbar.component";
import {LottieModule} from "ngx-lottie";

if (isProdMode()) {
  Bugsnag.start({ apiKey: window['bugsnagApiKey'] });
}


export function isProdMode() {
  return true;
}
export function errorHandlerFactory() {
  return isProdMode() ? new BugsnagChunkLoadErrorHandler() : new ChunkLoadErrorHandler();
}

export function configFactory(httpClient: HttpClient): ConfigLoader {
  return new ConfigHttpLoader(httpClient, './assets/config.json');
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export function intercomAppId(): string {
  return window["intercomAppId"];
}

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [ImageDetailComponent, PhotoDetailComponent, SnackbarComponent],
  imports: [
    SharedModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ConfigModule.forRoot({
      provide: ConfigLoader,
      useFactory: configFactory,
      deps: [HttpClient]
    }),
    LottieModule.forRoot({ player: playerFactory } ),
    LottieModule
  ],
  providers: [
    { provide: ErrorHandler, useFactory: errorHandlerFactory },
    /*  TODO: See with Yassir if its needed as we already have bugsnag
        {
          // processes all errors
          provide: ErrorHandler,
          useClass: GlobalErrorHandler
        }*/
  ],
  entryComponents: [
    ImageDetailComponent, PhotoDetailComponent
  ],
})
export class CoreModule { }
